import { observer } from 'mobx-react-lite'
import React from 'react'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'

import { Text } from '@mxenabled/mxui'
import { ChevronRight } from '@mxenabled/mx-icons'
import { Dialog, useGlobalCopyStore, useSettingsStore, useUserStore } from '../../../../common'
import VerifyTokenAction from './VerifyTokenAction'

const VerifyPhoneAction = observer(() => {
  const { common: commonCopy, settings: settingsCopy } = useGlobalCopyStore()
  const { sendPhoneVerification, verifyPhoneToken } = useSettingsStore()
  const { user } = useUserStore()
  const theme = useTheme()

  const [isOpen, setIsOpen] = React.useState(false)
  const [showVerifyToken, setShowVerifyToken] = React.useState(false)

  const handleClose = (): void => {
    setIsOpen(false)
  }

  const handleOpen = (): void => {
    setIsOpen(true)
  }

  const handlePhoneVerify = () => {
    sendPhoneVerification().finally(() => {
      setShowVerifyToken(true)
    })
  }

  const handleTokenVerify = (token: string) => {
    verifyPhoneToken(token).finally(() => {
      setShowVerifyToken(false)
    })
  }

  return (
    <React.Fragment>
      <Button onClick={handleOpen} sx={{ height: 'auto', p: 4, width: 'fit-content' }}>
        <Text variant="body2">{settingsCopy.verify_phone}</Text>
        <ChevronRight />
      </Button>
      <Dialog
        copy={{ title: settingsCopy.confirm_your_phone }}
        isOpen={isOpen}
        onClose={handleClose}
        onPrimaryAction={handlePhoneVerify}
        onSecondaryAction={handleClose}
        primaryText={settingsCopy.send_verification}
        secondaryText={commonCopy.back}
        sx={{
          '& .MuiDialogContent-root': { pt: 0, width: 400 },

          '& .MuiToolbar-root:last-child': {
            gap: 16,
            padding: '32px 60px 48px',
            justifyContent: 'center',
          },
        }}
      >
        <Stack spacing={16} sx={{ px: 40, textAlign: 'center', width: '100%' }}>
          <Text truncate={false} variant="body2">
            {settingsCopy.confirm_phone}
          </Text>
          <Text
            sx={{
              border: `1px solid ${theme.palette.neutral.light}`,
              borderRadius: '4px',
              p: '16px 32px',
            }}
            variant="h3"
          >
            {user.phone}
          </Text>
          <Text truncate={false} variant="body2">
            {settingsCopy.verification_notice_phone}
          </Text>
        </Stack>
      </Dialog>
      <VerifyTokenAction
        handleClose={() => setShowVerifyToken(false)}
        handleVerify={handleTokenVerify}
        isOpen={showVerifyToken}
      />
    </React.Fragment>
  )
})

export default VerifyPhoneAction
